import ApiService from "../services/ApiService.mjs";
import BanklinkStore from "./BanklinkStore.mjs";
import BrandStore from "./BrandStore.mjs";
import CardManagerStore from "./CardManagerStore.mjs";
import CardStore from "./CardStore.mjs";
import PaymentStore from "./PaymentStore.mjs";
import SettingsStore from "./SettingsStore.mjs";
import TabStore from "./TabStore.mjs";
import TranslateStore from "./TranslateStore.mjs";
class RootStore {
  static ROOT_STORE = new RootStore();
  apiService;
  banklinkStore;
  settingsStore;
  paymentStore;
  translateStore;
  tabStore;
  brandStore;
  cardStore;
  cardManagerStore;
  constructor() {
    this.apiService = new ApiService();
    this.tabStore = new TabStore();
    this.brandStore = new BrandStore();
    this.translateStore = new TranslateStore(this.apiService, this.brandStore);
    this.paymentStore = new PaymentStore(this.translateStore);
    this.banklinkStore = new BanklinkStore(this.apiService, this.paymentStore);
    this.settingsStore = new SettingsStore(this.apiService);
    this.cardManagerStore = new CardManagerStore();
    this.cardStore = new CardStore(this.apiService, this.paymentStore, this.cardManagerStore);
  }
  static instance = () => RootStore.ROOT_STORE;
}
export {
  RootStore as default
};
